//
// Teacher store
//

import * as client from 'api/client';
import { LOGOUT, getToken } from './auth';
import { RECEIVE_ENTITIES } from './user';
import { showSuccess, showError } from './messages';

// ------------------------------------
// Action definitions
// ------------------------------------

export const CREATE_TEACHER  = 'TEACHERS/CREATE';
export const TEACHER_CREATED = 'TEACHERS/CREATE_OK';
export const DELETE_TEACHER  = 'TEACHERS/DELETE';
export const TEACHER_DELETED = 'TEACHERS/DELETE_OK';
export const ERROR           = 'TEACHERS/ERROR';

// ------------------------------------
// Action creators
// ------------------------------------

export const createTeacher = (name, email, classId) => (dispatch, getState) => {
  dispatch({ type: CREATE_TEACHER });

  const state = getState();
  const token = getToken(state);

  const data = {
    name,
    email,
    class_id: classId
  };

  return client.post(`/api/teachers`, data, token)
    .then(user => {
      dispatch({ type: TEACHER_CREATED, user, classId });
      dispatch(showSuccess('teacher.create.success'));
    })
    .catch(error => {
      dispatch(fail());
      dispatch(showError('teacher.create.failed'));
    });
};

// class, teacher
export const deleteTeacher = (classId, teacherId) => (dispatch, getState) => {
  dispatch({ type: DELETE_TEACHER });

  const state = getState();
  const token = getToken(state);

  return client.del(`/api/classes/${classId}/teacher/${teacherId}`, token)
  .then(() => {
    dispatch({ type: TEACHER_DELETED, classId, teacherId });
    dispatch(showSuccess('teacher.delete.success'));
  })
  .catch(error => {
    dispatch(fail());
    dispatch(showError('teacher.delete.failed'));
  });
};

export const fail = () => ({ type: ERROR });

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  items: {},
  pending: false
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_ENTITIES:
      return {
        ...state,
        items: action.entities.teachers || {}
      };

    case CREATE_TEACHER:
    case DELETE_TEACHER:
      return {
        ...state,
        pending: true
      };

    case TEACHER_CREATED:
      const { user } = action;

      return {
        ...state,
        items: { ...state.items, [user.id]: user },
        pending: false
      };

    case TEACHER_DELETED:
      // Don't delete teacher as it can still be referenced from other classes.
      return state;

    case ERROR:
      return {
        ...state,
        pending: false
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

// ------------------------------------
// Utils
// ------------------------------------

export const getTeachers = (state, ids) => {
  const teachers = state.teachers.items;
  return ids.map(id => teachers[id]);
};



// WEBPACK FOOTER //
// ./src/store/modules/teachers.js